export enum ItemCardRenderType {
  button = "button",
  link = "link",
  static = "static",
}
